import { useEffect, useState } from "react";

import { useMerchantApiMutation } from ".";
import { ISwAppApi } from "../interfaces-and-types";

export const useEditItemProperties = <TItem>(
  editQueryKey: keyof ISwAppApi,
  refreshView: () => void
) => {
  const [itemToEditId, setItemToEditId] = useState<string | null>(null);
  const [itemToEdit, setItemToEdit] = useState<TItem | null>(null);
  const [isItemEditLocked, setItemEditLocked] = useState(false);
  const [autoInvokeAction, setAutoInvokeAction] = useState(false);

  const isEditModalOpen =
    itemToEditId !== null && itemToEditId !== "" && !autoInvokeAction;

  const openEditModal = (
    id: string,
    editedItem: TItem,
    isEditLocked: boolean,
    autoInvokeAction: boolean = false
  ) => {
    setItemToEditId(id);
    setItemEditLocked(isEditLocked);

    setItemToEdit(editedItem);
    setAutoInvokeAction(autoInvokeAction);
  };

  const closeEditModal = () => {
    setItemToEditId(null);
    setItemToEdit(null);
    setAutoInvokeAction(false);
  };

  const {
    isLoading: isLoadingEditItem,
    isSuccess: isSuccessEditItem,
    mutate: editItemMutate,
  } = useMerchantApiMutation<TItem, null>(editQueryKey, [], {}, (urlTemplate) =>
    urlTemplate.replace("id", itemToEditId!)
  ).usePutMutation;

  const editItem = () => editItemMutate(itemToEdit);

  useEffect(() => {
    if (autoInvokeAction && itemToEdit != null) {
      editItem();
    }
  }, [autoInvokeAction]);

  useEffect(() => {
    if (isSuccessEditItem) {
      refreshView && refreshView();
      closeEditModal();
    }
  }, [isSuccessEditItem]);

  return {
    isEditModalOpen,
    openEditModal,
    closeEditModal,

    isItemEditLocked,

    isLoadingEditItem,
    isSuccessEditItem,
    editItem,
  };
};
